// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gqcbi{padding:41px 32px 69px;background-color:#f6f6f6}`, "",{"version":3,"sources":["webpack://./src/components/stepSection/StepSection.module.scss"],"names":[],"mappings":"AAAA,OACE,sBAAA,CACA,wBAAA","sourcesContent":[".container {\n  padding: 41px 32px 69px;\n  background-color: #f6f6f6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Gqcbi`
};
export default ___CSS_LOADER_EXPORT___;
